module.exports = __webpack_public_path__ + "static/media/ativar.40821f74.svg";